import React, { useState } from 'react'
import Ticket from '../../Components/Ticket'
import Header from '../../Components/Header'
import Footer from '../../Components/AppLayout/Footer'


const ScanTicket = () => {

    return (
        <>
            <Header position={'fixed'} activeLink='' subPage={false} />
            <div className='scan-ticket__wrapper'>
                <Ticket />
            </div>
            <Footer />



        </>

    )
}

export default ScanTicket